/**
 * Possible Users
 */
const ROLES = ['FC', 'DES', 'DEO', 'CCM', 'AA', 'CM', 'OM', 'KDA'];
/**
 * Possible Users
 */
export const USER_ROLES = { fc: 'FC', des: 'DES', deo: 'DEO', ccm: 'CCM', aa: 'AA', cm: 'CM', OM: 'OM', KDA: 'KDA' };

export default ROLES;
